import ErrorBoundaryFallbackV2 from './error-boundary-fallback'

export default ErrorBoundaryFallbackV2
